import { Typography, useTheme } from "@mui/material";
import type { FC } from "react";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { BoxedSliderField } from "web_myplann/Inspiration/Components/BoxedSliderField";
import { InspirationAnchorList } from "web_myplann/Inspiration/Components/InspirationAnchorList";
import { InspirationSection } from "web_myplann/Inspiration/Components/InspirationSection";
import {
	EARLY_FREEDOM_LIFESTYLE_ANCHORS,
	EARLY_FREEDOM_TARGET_MAX,
	EARLY_FREEDOM_TARGET_MIN,
	EARLY_FREEDOM_TARGET_STEP,
} from "web_myplann/Inspiration/EarlyFreedom/constants";
import { mapEarlyFreedomAnchor } from "web_myplann/Inspiration/EarlyFreedom/Mappers/mapEarlyFreedomAnchor";
import type { EarlyFreedomAnchorKey } from "web_myplann/Inspiration/EarlyFreedom/Types/EarlyFreedomTypes";

const R = Resources.Inspiration.EarlyFreedom;

type Props = {
	targetExpenses: number;
	activeAnchorKey: EarlyFreedomAnchorKey;
	onChange: (value: number) => void;
};

export const EarlyFreedomTargetSection: FC<Props> = ({
	targetExpenses,
	activeAnchorKey,
	onChange,
}) => {
	const { t } = useResource();
	const theme = useTheme();

	const activeAnchor = EARLY_FREEDOM_LIFESTYLE_ANCHORS.find(
		(anchor) => anchor.key === activeAnchorKey,
	);

	return (
		<InspirationSection title={t(R.targetTitle)} gap={theme.spacingTokens.md}>
			<Typography variant="body2" lineHeight={1.625}>
				{t(R.targetDescription)}
			</Typography>

			<InspirationAnchorList
				anchors={EARLY_FREEDOM_LIFESTYLE_ANCHORS.map((anchor) =>
					mapEarlyFreedomAnchor(anchor, activeAnchorKey, targetExpenses),
				)}
				activeKey={activeAnchorKey}
				onSelect={onChange}
			/>

			<BoxedSliderField
				label={t(R.targetSliderLabel)}
				value={targetExpenses}
				onChange={onChange}
				min={EARLY_FREEDOM_TARGET_MIN}
				max={EARLY_FREEDOM_TARGET_MAX}
				step={EARLY_FREEDOM_TARGET_STEP}
			/>

			{activeAnchor && (
				<Typography variant="hint" color={theme.palette.grey[500]}>
					{t(activeAnchor.copy.description)}
				</Typography>
			)}
		</InspirationSection>
	);
};
